import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchCopyableContentArgs } from '../api/contentCopy.api';

import { fetchCopyableContent } from '../api/contentCopy.api';

// WS2 — "copy to organization" dialog's own-content picker lists.
export const contentCopyQueryKeys = createQueryKeys('contentCopy', {
  fetchCopyableContent: (args: FetchCopyableContentArgs) => ({
    queryFn: () => fetchCopyableContent(args),
    queryKey: [args.organizationId, args.type, args.userId, args.locale],
  }),
});
